/**
 * Product card slider pagination (mobile line dots).
 * Runs after theme.js init — does not modify theme.js.
 */
(function () {
  const ENHANCED_FLAG = 'cardSliderEnhanced';

  function getSwiperConfig(sliderEl) {
    const paginationEl = sliderEl.querySelector('.card__slider-pagination');

    const config = {
      slidesPerView: 'auto',
      navigation: {
        nextEl: sliderEl.querySelector('.swiper-button-next'),
        prevEl: sliderEl.querySelector('.swiper-button-prev'),
      },
    };

    if (paginationEl) {
      config.pagination = {
        el: paginationEl,
        clickable: true,
      };
    }

    return config;
  }

  function initCardSlider(sliderEl) {
    if (typeof Swiper === 'undefined' || !sliderEl) return;
    if (!sliderEl.querySelector('.card__slider-pagination')) return;

    if (sliderEl.swiper) {
      sliderEl.swiper.destroy(true, true);
    }

    new Swiper(sliderEl, getSwiperConfig(sliderEl));
    sliderEl.dataset[ENHANCED_FLAG] = 'true';
  }

  function waitForThemeInit(sliderEl) {
    if (sliderEl.dataset[ENHANCED_FLAG] === 'true') return;

    if (sliderEl.classList.contains('swiper-initialized') || sliderEl.swiper) {
      initCardSlider(sliderEl);
      return;
    }

    const observer = new MutationObserver(() => {
      if (!sliderEl.classList.contains('swiper-initialized') && !sliderEl.swiper) return;

      observer.disconnect();
      setTimeout(() => initCardSlider(sliderEl), 0);
    });

    observer.observe(sliderEl, { attributes: true, attributeFilter: ['class'] });
  }

  function setupCardSliders() {
    document.querySelectorAll('.card__media .card__slider').forEach((sliderEl) => {
      if (!sliderEl.querySelector('.card__slider-pagination')) return;
      waitForThemeInit(sliderEl);
    });
  }

  function setupCardSlidersAfterFilter() {
    document.querySelectorAll('.card__media .card__slider').forEach((sliderEl) => {
      if (!sliderEl.querySelector('.card__slider-pagination')) return;
      delete sliderEl.dataset[ENHANCED_FLAG];
      initCardSlider(sliderEl);
    });
  }

  document.addEventListener('DOMContentLoaded', setupCardSliders);

  if (typeof subscribe === 'function') {
    subscribe('filter-render', () => {
      setTimeout(setupCardSlidersAfterFilter, 100);
    });
  }
})();
